import { useContext } from 'react'

import { ResellerContext } from 'src/components/molecules/ResellerProvider'

export const useResellerContext = () => {
  return useContext(ResellerContext)
}
